// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"6cd31d9f","791":"622cb1a0"}[chunkId] + ".chunk.css";
};